// removed by extract-text-webpack-plugin
module.exports = {"blue":"#00A8E8","dark":"#00171F","darkTo":"#002A3B","darkBlue":"#065679","white":"#FFFFFF","black":"#000000","green":"#99C24D","orange":"#F18F01","gray":"#EFEFEF","darkGradient":"radial-gradient(#002A3B 0%, #00171F 94.96%)","bp":"(min-width: 700px)"};


//////////////////
// WEBPACK FOOTER
// ./src/vars.css
// module id = 209
// module chunks = 35783957827783 114276838955818